var Model = function Model(value, animate) {
    if ( value === void 0 ) value = 0;

    this.handle = {
        transform: 'translateX(' + value + 'px)',
        transition: animate
    };
};

export default Model;



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@telerik/kendo-inputs-common/dist/es/SwitchModel.js
// module id = ../../../../@telerik/kendo-inputs-common/dist/es/SwitchModel.js
// module chunks = vendor